import { atom } from 'jotai';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { IArticleRelatedPostWithImmersiveData, $ArticleRelatedPostWithImmersiveData } from 'shared/atoms';

export const $ArticleRelatedPostWithImmersiveDataLoadmore = safeAtomFamily((groupId: string) => {
  const a = atom(null, async (get, set, input: IArticleRelatedPostWithImmersiveData) => {
    const { items, searchId } = await get($ArticleRelatedPostWithImmersiveData(groupId));

    set($ArticleRelatedPostWithImmersiveData(groupId), {
      ...input,
      items: [...items, ...input.items],
      searchId, // searchId remains unchanged when load more
    });
  });

  a.debugLabel = `$ArticleRelatedPostWithImmersiveDataLoadmore+${encodeURIComponent(groupId)}`;

  return a;
});
